import { useQuery } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useGetUser(userId: number | string) {
  const getUser = async () => {
    const response = await http.get(`/user/${userId}`);
    return response.data;
  };

  return useQuery({
    queryKey: ["user", userId],
    queryFn: getUser,
  });
}
